<div class="transcript-container">
  @if (transcriptChunks.length) {
    <div class="transcript-chunks flex flex-col flex-grow">
      <div class="transcript-content">
        @if (savedQuoteIds$ | async; as savedQuoteIds) {
          @for (chunk of transcriptChunks; track trackChunk($index, chunk)) {
            <div class="chunk" [class.highlight]="chunk.highlighted">
              <div class="flex flex-row justify-between items-center">
                <span>
                  {{ chunk.timestampStartTimestamp }} -->
                  {{ chunk.timestampEndTimestamp }}
                </span>
                <div>
                  <mat-icon
                    [matTooltip]="
                      savedQuoteIds.has(chunk.transcriptChunkId)
                        ? 'Unfavorite'
                        : 'Favorite'
                    "
                    [class.loading]="chunk.loading"
                    (click)="updateQuote(chunk)"
                  >
                    {{
                      chunk.loading
                        ? 'autorenew'
                        : savedQuoteIds.has(chunk.transcriptChunkId)
                          ? 'star'
                          : 'star_outlined'
                    }}
                  </mat-icon>
                  @if (hasAudio && chunk.audioChunkFileKey) {
                    <mat-icon
                      [matTooltip]="
                        chunk.downloading ? 'Loading' : 'Download audio snippet'
                      "
                      [class.loading]="chunk.downloading"
                      (click)="downloadTranscriptChunk(chunk)"
                    >
                      {{ chunk.downloading ? 'autorenew' : 'file_download' }}
                    </mat-icon>
                  }
                </div>
              </div>
              <span>
                <b>{{ chunk.speaker }}</b
                >:
                {{
                  enhancedPlayback
                    ? chunk.normalisedText || chunk.text
                    : chunk.text
                }}
              </span>
            </div>
          }
        }
      </div>
    </div>

    <div class="transcript-audio" [style.min-height]="hasAudio ? '125px' : '0'">
      <div class="flex items-center justify-between">
        @if (hasAudio) {
          <b>Audio</b>
        }
        @if (showPlaybackLanguage) {
          <div class="flex gap-2 items-center">
            <span>Translated</span>
            <mat-slide-toggle [(ngModel)]="enhancedPlayback"></mat-slide-toggle>
          </div>
        }
        @if (hasAudio) {
          <div class="flex gap-2 items-center">
            <span>Auto scroll</span>
            <mat-slide-toggle [(ngModel)]="autoScroll"></mat-slide-toggle>
          </div>
        }
      </div>
      @if (hasAudio) {
        <audio
          #audioPlayer
          controls
          [audioTime]="audioStartTime"
          [src]="audioData"
          (timeupdate)="updateTime($event)"
        >
          Your browser does not support the audio element.
        </audio>
      } @else {
        <div
          class="transcript-only-indicator flex items-center gap-1"
          data-testid="transcript-only-indicator"
        >
          <mat-icon>info_outline</mat-icon>
          <span>Transcript only, no audio</span>
        </div>
      }
    </div>
  } @else {
    <div class="transcript-container progress" style="min-height: 125px">
      Transcription in progress
    </div>
  }
</div>
